import { getResponseData } from "@helpers/_functions";

import http from "../http-common";
import BaseService from "./base.service";

class SalaryTemplate extends BaseService {
  constructor() {
    super("salary-template");
  }

  duplicateOne(id) {
    return http
      .post(`${this.path}/duplicate/${id}`)
      .then((response) => getResponseData(response));
  }
}

export default new SalaryTemplate();
